import Keycloak from 'keycloak-js';
import { loadAuthConfigFile } from './authConfigFile';
import { startKeycloakTokenRefresh } from './keycloakTokenRefresh';

let keycloakInstance: Keycloak | null = null;
let initPromise: Promise<boolean> | null = null;

export function getKeycloak(): Keycloak {
  if (!keycloakInstance && window.mockKeycloak) {
    keycloakInstance = window.mockKeycloak;
  }

  if (!keycloakInstance) {
    throw new Error('Keycloak has not been initialized yet');
  }

  return keycloakInstance;
}

export function initKeycloak(): Promise<boolean> {
  if (!initPromise) {
    initPromise = (async () => {
      if (window.mockKeycloak) {
        keycloakInstance = window.mockKeycloak;
        return Boolean(keycloakInstance.authenticated);
      }

      const authConfig = await loadAuthConfigFile();

      keycloakInstance = new Keycloak({
        url: authConfig.keyCloakURL,
        realm: authConfig.keyCloakRealm,
        clientId: authConfig.keyCloakClientId,
      });

      const authenticated = await keycloakInstance.init({
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      });

      startKeycloakTokenRefresh(keycloakInstance);

      return authenticated;
    })();
  }

  return initPromise;
}
